import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { Accordion } from '../Accordion'
import { BodyLarge, BodyLargeMedium } from '../styles/Typography'
import { useTranslation } from 'react-i18next'
import { HealthPlanOutcome } from '../../api/ester-b2b-api/private/healthPlan/types'
import { PreviewGuard } from '../PreviewGuard'
import { useEmitEvent } from '../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'

type OutcomesProps = {
  outcomes?: HealthPlanOutcome[]
  title?: string
  description?: string
}

export const Outcomes = ({ outcomes, title, description }: OutcomesProps) => {
  const { t } = useTranslation()
  const emitEvent = useEmitEvent()

  const handleOutcomeToggle = (outcome: HealthPlanOutcome, isOpen: boolean) => {
    if (isOpen) {
      emitEvent({
        eventType: TrackingEvents.OPEN_OUTCOME,
        options: {
          metadata: {
            outcome: outcome.title || outcome.outcomeId,
          },
        },
      })
    }
  }

  if (!outcomes || outcomes.length === 0) {
    return <PreviewGuard />
  }

  return (
    <>
      <BodyLargeMedium>{title ?? t('employee.yourHealth.yourOutcomes')}</BodyLargeMedium>
      <BodyLarge>{description ?? t('employee.yourHealth.yourOutcomesDescription')}</BodyLarge>
      <OutcomeContainer>
        {outcomes.map((outcome) => (
          <Accordion
            key={outcome.outcomeId}
            title={outcome.title || ''}
            defaultOpen
            onToggle={(isOpen) => handleOutcomeToggle(outcome, isOpen)}
          >
            <Content>{outcome.content}</Content>
          </Accordion>
        ))}
      </OutcomeContainer>
    </>
  )
}

const Content = styled.div`
  padding: ${theme.spacing.small}px 0px;
`

const OutcomeContainer = styled.div`
  border-radius: ${theme.spacing.medium}px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: ${theme.spacing.mediumLarge}px;
  padding-top: ${theme.spacing.large}px;
  width: 100%;
  align-items: flex-start;
`
